export enum FilterTypes {
  owner = 'owner',
  modifiedTime = 'modifiedTime',
  tag = 'tag',
}
